export default {
	'WordPressAcf_article_bubble_images': 'BubbleImages',
	'WordPressAcf_article_image': 'Image',
	'WordPressAcf_article_quote': 'Quote',
	'WordPressAcf_article_text': 'Text',
	'WordPressAcf_article_video': 'Video'
}